export class ClientChooserWhitelistService {
	constructor() {
		'ngInject';
		this.whitelist = [];
		this.filter = this.filter.bind(this);
		this.filterAffiliation = this.filterAffiliation.bind(this);
		this.filterHub = this.filterHub.bind(this);
	}

	filter(hub) {
		if (this.filterAffiliation(hub) || this.filterHub(hub)) {
			return true;
		}
		return false;
	}

	filterAffiliation(hub) {
		let affs = this.whitelist['affiliation_ids'];
		if (!affs || !Array.isArray(affs)) {
			return true;
		}

		if (!affs.length) {
			return false;
		}

		affs = affs.map(Number);
		if (affs.includes(hub.account_id)) {
			return true;
		}

		return false;
	}

	filterHub(hub) {
		let hubs = this.whitelist['hub_ids'];
		if (!hubs || !Array.isArray(hubs)) {
			return true;
		}

		if (!hubs.length) {
			return false;
		}

		hubs = hubs.map(Number);
		if (hubs.includes(hub.id)) {
			return true;
		}

		return false;
	}
}
